import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { SBHorizontal } from '@sorare/core/src/atoms/layout/flex';

import { LeftLiveLineupFooter } from './LeftLiveLineupFooter';
import { RightLiveLineupFooter } from './RightLiveLineupFooter';
import { LiveLineupFooter_so5LeaderboardContender } from './__generated__/index.graphql';

const Root = styled(SBHorizontal)`
  width: 100%;
`;

type Props = {
  so5LeaderboardContender: LiveLineupFooter_so5LeaderboardContender;
  onClickPrizePool?: () => void;
};

export const LiveLineupFooter = ({
  so5LeaderboardContender,
  onClickPrizePool,
}: Props) => {
  return (
    <Root>
      <LeftLiveLineupFooter so5LeaderboardContender={so5LeaderboardContender} />
      <RightLiveLineupFooter
        so5LeaderboardContender={so5LeaderboardContender}
        onClick={onClickPrizePool}
      />
    </Root>
  );
};

LiveLineupFooter.fragments = {
  so5LeaderboardContender: gql`
    fragment LiveLineupFooter_so5LeaderboardContender on So5LeaderboardContender {
      slug

      ...RightLiveLineupFooter_so5LeaderboardContender
      ...LeftLiveLineupFooter_so5LeaderboardContender
    }
    ${LeftLiveLineupFooter.fragments.so5LeaderboardContender}
    ${RightLiveLineupFooter.fragments.so5LeaderboardContender}
  ` as TypedDocumentNode<LiveLineupFooter_so5LeaderboardContender>,
};
